module.exports = __webpack_public_path__ + "img/dap_market_share_metodology.5b403f25.png";